import { render, staticRenderFns } from "./pointGoodsCat.vue?vue&type=template&id=64112e90&"
import script from "./pointGoodsCat.vue?vue&type=script&lang=js&"
export * from "./pointGoodsCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports